import * as moment from 'moment'

export function Years () {
  const years = []
  const startAt = 1900
  const finishAt = moment().get('y')
  for (let i = finishAt; i >= startAt; i--) {
    years.push({
      value: `${i}`,
      text: `${i}`
    })
  }
  return years
}

export function ExtinguisherCompanies () {
  return [
    { value: 'amarex', text: 'Amerex' },
    { value: 'ansul', text: 'Ansul' },
    { value: 'badger', text: 'Badger' },
    { value: 'buckeye', text: 'Buckeye' },
    { value: 'chubb', text: 'Chubb' },
    { value: 'cotwo', text: 'Cotwo' },
    { value: 'diamond', text: 'Diamond' },
    { value: 'flag', text: 'Flag' },
    { value: 'general', text: 'General' },
    { value: 'kidde', text: 'Kidde' },
    { value: 'pyrene', text: 'Pyrene' },
    { value: 'pyrochem', text: 'Pyrochem' },
    { value: 'safetyfirst', text: 'Safety First' },
    { value: 'strikefirst', text: 'Strike First' },
    { value: 'william', text: 'William' }
  ]
}

export function ExtinguisherTypes () {
  return [
    { value: 'abc', text: 'ABC' },
    { value: 'bc', text: 'BC' },
    { value: 'd', text: 'D' },
    { value: 'k', text: 'K' },
    { value: 'halotron', text: 'Halotron' },
    { value: 'fe36', text: 'FE36' },
    { value: 'cleanguard', text: 'Cleanguard' },
    { value: 'co2', text: 'CO2' },
    { value: 'eau', text: 'Eau' },
    { value: 'acmist', text: 'AC mist' }
  ]
}

export function ExtinguisherFormats () {
  return [
    { value: '2.5', text: '2.5' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '9', text: '9' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '13', text: '13' },
    { value: '15', text: '15' },
    { value: '15.5', text: '15.5' },
    { value: '20', text: '20' },
    { value: '30', text: '30' },
    { value: '50', text: '50' },
    { value: '75', text: '75' },
    { value: '100', text: '100' },
    { value: '150', text: '150' }
  ]
}

export function BatteryType () {
  return [
    { value: '6v4a', text: '6v4a' },
    { value: '6v7a', text: '6v7a' },
    { value: '6v12a', text: '6v12a' },
    { value: '12v4a', text: '12v4a' },
    { value: '12v7a', text: '12v7a' },
    { value: '12v12a', text: '12v12a' },
    { value: '12v18a', text: '12v18a' },
    { value: '12v26a', text: '12v26a' },
    { value: '12v30a', text: '12v30a' }
  ]
}

export function BatteryModel () {
  return [
    { value: '6v4a', text: '6v4a' },
    { value: '5', text: '6v7a' },
    { value: '6', text: '6v12a' },
    { value: '9', text: '12v4a' },
    { value: '10', text: '12v7a' },
    { value: '11', text: '12v12a' },
    { value: '13', text: '12v18a' },
    { value: '15', text: '12v26a' },
    { value: '15.5', text: '12v30a' }
  ]
}

export function ExtincteurClass () {
  return [
    { value: '1a10bc', text: '1a10bc' },
    { value: '3a10bc', text: '3a10bc' },
    { value: '3a40bc', text: '3a40bc' },
    { value: '4a60bc', text: '4a60bc' },
    { value: '4a80bc', text: '4a80bc' },
    { value: '6a80bc', text: '6a80bc' },
    { value: '10a80bc', text: '10a80bc' },
    { value: '10a120bc', text: '10a120bc' },
    { value: '5bc', text: '5bc' },
    { value: '6bc', text: '6bc' },
    { value: '8bc', text: '8bc' },
    { value: '10bc', text: '10bc' },
    { value: '2ac', text: '2ac' },
    { value: 'k', text: 'K' }
  ]
}

export function LightingModel () {
  return [
    { value: 'RG27-2MT9W', text: 'RG27-2MT9W' },
    { value: 'RG44-2MT9W', text: 'RG44-2MT9W' },
    { value: 'RG72-2MT9W', text: 'RG72-2MT9W' },
    { value: 'RG108-2MT9W', text: 'RG108-2MT9W' },
    { value: 'RG180-2MT9W', text: 'RG180-2MT9W' },
    { value: 'RG12S72-2MT9W', text: 'RG12S72-2MT9W' },
    { value: 'RG12S100-2MT9W', text: 'RG12S100-2MT9W' },
    { value: 'RG12S144-2MT9W', text: 'RG12S144-2MT9W' },
    { value: 'RG12S200-2MT9W', text: 'RG12S200-2MT9W' },
    { value: 'RG12S360-2MT9W', text: 'RG12S360-2MT9W' },
    { value: 'RG24S144-2MT9W', text: 'RG24S144-2MT9W' },
    { value: 'RG24S350-2MT9W', text: 'RG24S350-2MT9W' },
    { value: 'RG24S550-2MT9W', text: 'RG24S550-2MT9W' },
    { value: 'RG24S720-2MT9W', text: 'RG24S720-2MT9W' },
    { value: 'COMB0-6-V-27-W', text: 'COMB0 6 V 27 W' },
    { value: 'COMB0-6-V-50-W', text: 'COMB0 6 V 50 W' },
    { value: 'SORTIE-AUTOALIMENTE', text: 'SORTIE AUTOALIMENTE' },
    { value: 'COMB0-R-M-6V27W', text: 'COMB0 R-M 6 V 27 W' },
    { value: 'COMB0-R-M-6V24W-LED', text: 'COMB0 R-M 6 V 24 W LED' },
    { value: 'COMB0-R-M-6V28W-LED', text: 'COMB0 R-M 6 V 28 W LED' },
    { value: 'RG27-2MT-LED', text: 'RG27-2MT-LED' },
    { value: 'RG44-2MT-LED', text: 'RG44-2MT-LED' },
    { value: 'RG72-2MT-LED', text: 'RG72-2MT-LED' },
    { value: 'RG108-2MT-LED', text: 'RG108-2MT-LED' },
    { value: 'RG180-2MT-LED', text: 'RG180-2MT-LED' },
    { value: 'RG12S72-2MT-LED', text: 'RG12S72-2MT-LED' },
    { value: 'RG12S100-2MT-LED', text: 'RG12S100-2MT-LED' },
    { value: 'RG12S144-2MT-LED', text: 'RG12S144-2MT-LED' },
    { value: 'RG12S200-2MT-LED', text: 'RG12S200-2MT-LED' },
    { value: 'RG12S360-2MT-LED', text: 'RG12S360-2MT-LED' },
    { value: 'RG24S144-2MT-LED', text: 'RG24S144-2MT-LED' },
    { value: 'RG24S350-2MT-LED', text: 'RG24S350-2MT-LED' },
    { value: 'RG24S550-2MT-LED', text: 'RG24S550-2MT-LED' },
    { value: 'RG24S720-2MT-LED', text: 'RG24S720-2MT-LED' }
  ]
}

export function LightingSubUnit () {
  return [
    { value: 'MT-1', text: 'MT-1' },
    { value: 'MT-2', text: 'MT-2' },
    { value: 'MT-1_LED', text: 'MT-1  LED' },
    { value: 'MT-2_LED', text: 'MT-2  LED' },
    { value: 'SORTIE', text: 'SORTIE' },
    { value: 'SORTIE_LED', text: 'SORTIE LED' },
    { value: 'SORTIE_RUNNING_MAN', text: 'SORTIE RUNNING MAN' },
    { value: 'SORTIE_RUNNING_MAN_LED', text: 'SORTIE RUNNING MAN LED' }
  ]
}

export function YesNo () {
  return [
    { value: 'oui', text: 'Oui' },
    { value: 'non', text: 'Non' }
  ]
}
export function YesNoCom () {
  return [
    { value: 'oui', text: 'Oui' },
    { value: 'non', text: 'Non' },
    { value: 'commentaire', text: 'Commentaire' }
  ]
}

export function Conform () {
  return [
    { value: 'conforme', text: 'Conforme' },
    { value: 'nonconforme', text: 'Non-conforme' },
    { value: 'commentaire', text: 'Commentaire' }
  ]
}
export function ConformAdequat () {
  return [
    { value: 'adequat', text: 'Adéquat' },
    { value: 'nonconforme', text: 'Non-conforme' },
    { value: 'commentaire', text: 'Commentaire' }
  ]
}
export function ConformYes () {
  return [
    { value: 'oui', text: 'Oui' },
    { value: 'nonconforme', text: 'Non-conforme' },
    { value: 'commentaire', text: 'Commentaire' }
  ]
}

export function Normal () {
  return [
    { value: 'normal', text: 'Normal' },
    { value: 'nonApplicable', text: 'Non-applicable' },
    { value: 'anomalie', text: 'Anomalie' }
  ]
}

export function Replace () {
  return [
    { value: 'adequat', text: 'Adéquat' },
    { value: 'replacer', text: 'Remplacer' },
    { value: 'commentaire', text: 'Commentaire' }
  ]
}

export function FuiteEtanche () {
  return [
    { value: 'etache', text: 'Étanche' },
    { value: 'fuite', text: 'Fuites' }
  ]
}
export function ReussiEchec () {
  return [
    { value: 'reussite', text: 'Réussite' },
    { value: 'echec', text: 'Échec' }
  ]
}

export function InterrupteurModel () {
  return [
    { value: '--POTTER--', text: '--POTTER--' },
    { value: 'ADPS', text: 'ADPS' },
    { value: 'PS10-1', text: 'PS10-1' },
    { value: 'PS10-2', text: 'PS10-2' },
    { value: 'PS10-EX', text: 'PS10-EX' },
    { value: 'PS15-2', text: 'PS15-2' },
    { value: 'PS25-2', text: 'PS25-2' },
    { value: 'PS40-1', text: 'PS40-1' },
    { value: 'PS40-2', text: 'PS40-2' },
    { value: 'PS40-EX', text: 'PS40-EX' },
    { value: 'PS100-2', text: 'PS100-2' },
    { value: 'PS120-1', text: 'PS120-1' },
    { value: 'PS120-2', text: 'PS120-2' },
    { value: 'VSR-M', text: 'VSR-M' },
    { value: 'VSR', text: 'VSR' },
    { value: 'VSR-10', text: 'VSR-10' },
    { value: 'VSR-AT', text: 'VSR-AT' },
    { value: 'VSR-S', text: 'VSR-S' },
    { value: 'VSR-SG', text: 'VSR-SG' },
    { value: 'VSR-ST', text: 'VSR-ST' },
    { value: 'VSR-C', text: 'VSR-C' },
    { value: 'VSR-FE-2', text: 'VSR-FE-2' },
    { value: 'VSG', text: 'VSG' },
    { value: 'VSR-FEX', text: 'VSR-FEX' },
    { value: '--SYSTEM SENSOR--', text: '--SYSTEM SENSOR--' },
    { value: 'EPSA10-1', text: 'EPSA10-1' },
    { value: 'EPSA10-2', text: 'EPSA10-2' },
    { value: 'EPSA40-1', text: 'EPSA40-1' },
    { value: 'EPSA40-2', text: 'EPSA40-2' },
    { value: 'EPSA120-1', text: 'EPSA120-1' },
    { value: 'EPSA120-2', text: 'EPSA120-2' },
    { value: 'WFD20NA', text: 'WFD20NA' },
    { value: 'WFD25NA', text: 'WFD25NA' },
    { value: 'WFD30NA', text: 'WFD30NA' },
    { value: 'WFD40NA', text: 'WFD40NA' },
    { value: 'WFD50NA', text: 'WFD50NA' },
    { value: 'WFD60NA', text: 'WFD60NA' },
    { value: 'WFD80NA', text: 'WFD80NA' },
    { value: 'WFDTNA', text: 'WFDTNA' },
    { value: 'WFDTNRNA', text: 'WFDTNRNA' },
    { value: 'WFDNFSA', text: 'WFDNFSA' },
    { value: 'WFDNFTA', text: 'WFDNFTA' }
  ]
}

export function CasseVideModel () {
  return [
    { value: '--wilkins--', text: '--Wilkins--' },
    { value: '350', text: '350' },
    { value: '350A', text: '350A' },
    { value: '350AST', text: '350AST' },
    { value: '375', text: '375' },
    { value: '375A', text: '375A' },
    { value: '375AST', text: '375AST' },
    { value: '375XL', text: '375XL' },
    { value: '450', text: '450' },
    { value: '475', text: '475' },
    { value: '950XL', text: '950XL' },
    { value: '950XLT', text: '950XLT' },
    { value: '975', text: '975' },
    { value: '975XL', text: '975XL' },
    { value: '975XL2', text: '975XL2' },

    { value: '--watts--', text: '--Watts--' },
    { value: '007', text: '007' },
    { value: '009', text: '009' },
    { value: '709', text: '709' },
    { value: '719', text: '719' },
    { value: '757', text: '757' },
    { value: '757/a', text: '57/a' },
    { value: '909', text: '909' },
    { value: '919', text: '919' },
    { value: '994', text: '994' },
    { value: 'LF007', text: 'LF007' },
    { value: 'LF009', text: 'LF009' },
    { value: 'LF709', text: 'LF709' },
    { value: 'LF719', text: 'LF719' },
    { value: 'LF909', text: 'LF909' },
    { value: 'LF919', text: 'LF919' },

    { value: '--apollo--', text: '--Apollo--' },
    { value: '4-200', text: '4-200' },
    { value: '40-100', text: '40-100' },
    { value: '40-200-T', text: '40-200-T' },
    { value: '40-200-T2S', text: '40-200-T2S' },
    { value: '40LF-100', text: '40LF-100' },
    { value: '4A-100', text: '4A-100' },
    { value: '4A-100LBF', text: '4A-100LBF' },
    { value: '4A-200LBF', text: '4A-200LBF' },
    { value: '4ALF-100', text: '4ALF-100' },
    { value: '4ALF-100 LBF', text: '4ALF-100 LBF' },
    { value: '4ALF-200', text: '4ALF-200' },
    { value: '4ALF-200LBF', text: '4ALF-200LBF' },
    { value: '4S-103', text: '4S-103' },

    { value: '--ames--', text: '--Ames--' },
    { value: '2000B', text: '2000B' },
    { value: '2000SS', text: '2000SS' },
    { value: '5000ss', text: '5000ss' },
    { value: 'C500', text: 'C500' },
    { value: 'C500N', text: 'C500N' },
    { value: 'C500Z', text: 'C500Z' },
    { value: 'Colt 200', text: 'Colt 200' },
    { value: 'Colt 200N', text: 'Colt 200N' },
    { value: 'LF2000B', text: 'LF2000B' },
    { value: 'M200', text: 'M200' },
    { value: 'M200N', text: 'M200N' },
    { value: 'autres', text: 'Autres' }
  ]
}

export function DispositifList () {
  return [
    { value: 'AF', text: 'AF' },
    { value: 'AG', text: 'AG' },
    { value: 'ANN', text: 'ANN' },
    { value: 'BOOS', text: 'BOOS' },
    { value: 'CC10', text: 'CC10' },
    { value: 'CL', text: 'CL' },
    { value: 'CL6', text: 'CL6' },
    { value: 'CL10', text: 'CL10' },
    { value: 'CONT', text: 'CONT' },
    { value: 'DA', text: 'DA' },
    { value: 'DC', text: 'DC' },
    { value: 'DFI', text: 'DFI' },
    { value: 'DFP', text: 'DFP' },
    { value: 'DUV', text: 'DUV' },
    { value: 'HP', text: 'HP' },
    { value: 'HT', text: 'HT' },
    { value: 'IBP', text: 'IBP' },
    { value: 'ID', text: 'ID' },
    { value: 'IFL', text: 'IFL' },
    { value: 'IHP', text: 'IHP' },
    { value: 'IPA', text: 'IPA' },
    { value: 'ISO', text: 'ISO' },
    { value: 'IV', text: 'IV' },
    { value: 'K', text: 'K' },
    { value: 'KP', text: 'KP' },
    { value: 'KV', text: 'KV' },
    { value: 'MR', text: 'M/R' },
    { value: 'MAD', text: 'MAD' },
    { value: 'PAI', text: 'PAI' },
    { value: 'PAR', text: 'PAR' },
    { value: 'PS', text: 'PS' },
    { value: 'PZ', text: 'PZ' },
    { value: 'PZ2', text: 'PZ2' },
    { value: 'RFL', text: 'RFL' },
    { value: 'RHT', text: 'RHT' },
    { value: 'RP', text: 'RP' },
    { value: 'Relais', text: 'Relais' },
    { value: 'S', text: 'S' },
    { value: 'SM', text: 'SM' },
    { value: 'SOL', text: 'SOL' },
    { value: 'SP', text: 'SP' },
    { value: 'TEL', text: 'TEL' }
  ]
}

export function FromTo (start, end, jump = 1, toFixed = 0) {
  const payload = []
  for (let i = start; ((end < start) ? i >= end : i <= end); i += jump) {
    payload.push({ value: `${i}`, text: `${i.toFixed(toFixed)}` })
  }
  return payload
}

/*
function convertObjToArray (obj) {
    const values = []
    for (const [key, value] of Object.entries(obj)) {
        values.push({
            value: `${key}`,
            text: `${value}`
        })
    }
    return values
}
*/
